// extracted by mini-css-extract-plugin
module.exports = {"switcher":"switcher_switcher__nXCMB","switchEl":"switcher_switchEl__k06xU","switchEl--choosen":"switcher_switchEl--choosen__2M1Mv"};